export const COLLECTION_GAPS = {
  ROW_GAP_DEFAULT: `--row-gap-default`,
  ROW_HORIZONTAL_PADDINGS_DEFAULT: `--row-horizontal-paddings-default`,
  GRID_GAP_VERTICAL: '--grid-gap-vertical',
  GRID_GAP_HORIZONTAL: '--grid-gap-horizontal',
  GRID_GAP_SEARCH_VERTICAL: '--grid-gap-search-vertical',
  GRID_GAP_SEARCH_HORIZONTAL: '--grid-gap-search-horizontal',
} as const
export type COLLECTION_GAPS =
  (typeof COLLECTION_GAPS)[keyof typeof COLLECTION_GAPS]
